import React from 'react'
import Layout from '../components/layout'
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Panel from '../components/panel'
import {post} from '../components/utils'
import {refreshActivityTimer} from '../components/timeout'
import {flex} from './../components/responsive'
import PageviewGA from '../components/pageview-ga'




class Body extends React.Component {

    constructor() {
        super()
        this.state = {show_spinner: false, error: false, success: false, employee_id: ""}
    }

    forceReset() {
        this.setState( {show_spinner: true, error: "", success: false} )
        post( "/api/admin/clear-pin", {"employee_id": this.refs.employee_id.getValue()}).then( (data) => {
            if ( data.treat_as_error ) {
                this.setState( {show_spinner: false, error: "Unable to clear PIN", success: false} )
            }
            else if ( data.http_status === 404 ) {
                this.setState( {show_spinner: false, error: "Employee not found", success: false} )
            }
            else {
                this.setState( {show_spinner: false, error: false, success: true} )
            }
        })
    }

    validate() {
        refreshActivityTimer()
        const employee_id = this.refs.employee_id.getValue()
        if ( isNaN(employee_id) ) return
        this.setState( {employee_id,  error: false, success: false})
    }


    render() {
        return(
            <div className="admin page-margin layout-row layout-align-center-start ">
                <div className={`layout-column ${flex(this.props.browser, [{"lt-md" : "100"},{"md" : "66"}, {"default" : "50"}])}`}>
                    <Panel title="Clear PIN and security questions" show_spinner={this.state.show_spinner}>
                        <h2>Employee ID:</h2>
                        <TextField style={{ width: "100%"}} maxLength="8" name="employee_id" value={this.state.employee_id} onChange={() => this.validate()} ref="employee_id" hintText="12345678"/>
                        <br/>
                        {this.state.error ? <div className="error">{this.state.error}</div> : <br/>}
                        {this.state.success ? <div className="success">Success</div> : <br/> }
                        <br/>
                        <RaisedButton disabled={this.state.employee_id.length !== 8 || this.state.show_spinner } fullWidth={true} label="CLEAR PIN" primary={true} onClick={() => this.forceReset()}/>
                        <br/>
                        <br/>
                    </Panel>
                </div>
            </div>
        )
    }
}


export default class extends React.Component {
    render() {
        return (
            <div className="layout-row flex">
                <PageviewGA/>
                <Layout title="Manage Users"
                        showAppBarActions={false}
                        {...this.props}
                        ready={true}
                        body={Body}>
                </Layout>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/admin.js